import type { PoLineStatus } from "@nexxt/contracts/procurement";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { procurementClient } from "../client";
import { purchaseOrderQueries } from "../purchase-order/purchase-order.queries";

// Server state of the lines of a PO (pattern.md §10), by cursor on the line number. Their keys are under the PO's,
// so whatever reloads a PO reloads its lines too.

const keys = {
  /** Every cached list of lines of a PO: a write puts the lines it gets back in each of them. */
  ofPurchaseOrder: (purchaseOrderId: string) => [...purchaseOrderQueries.of(purchaseOrderId), "lines"] as const,
};

export const lineQueries = {
  ...keys,

  list: (purchaseOrderId: string, status?: PoLineStatus | undefined) =>
    infiniteQueryOptions({
      queryKey: [...keys.ofPurchaseOrder(purchaseOrderId), { status }],
      queryFn: ({ pageParam, signal }) =>
        procurementClient().listPurchaseOrderLines(
          { purchaseOrderId, ...(status && { status }), ...(pageParam && { cursor: pageParam }) },
          signal,
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),
};
